module.exports = '2.1.8';



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/version.js
// module id = 1947
// module chunks = 0